import React, { useEffect, useState } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { withStore } from '@bigyellow/store';
import { handle_api_exception } from '@bigyellow/api/exception';
import { search } from '@bigyellow/api/register';
import ErrorMessages from '@bigyellow/components/Shared/ErrorMessages';

const initialFormState = {
    email: '',
    account_no: '',
    room_no: ''
}


const FindUserWithDetails = ({store, searchButtonText,OnComplete , showCancel,OnCancel,otherErrors}) => {

    const [submitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState([]);
    const [signUpDetails, setSignUpDetails] = useState(initialFormState);

    useEffect(() => {
        checkLdCookie();
    }, []);

    useEffect(() => {
        if(otherErrors){
            setErrors(otherErrors);
        }
    }, [otherErrors]);

    const checkLdCookie = () =>  {
        if (typeof document?.cookie !== 'undefined') {
            let cookie = document.cookie;

            cookie.split(';').map((item) => {
                let c = item.split('=');

                if (c[0].trim().toLowerCase() === 'ld') {
                    try {
                        const account_info = JSON.parse(atob(c[1].replace(/(%3D)+/, '')));
                        setSignUpDetails({email: account_info.customer_email,
                            account_no: account_info.customer_number,
                            room_no: account_info.room_number});

                    } catch (e) {
                        console.error(e);
                    }
                }
            })
        }
    }
    /**
     * Signup method
     *
     * @param values
     *
     */
    const onSubmitForm = (values) => {

        setSubmitting(true);
        const checkinDetails = {
            email: values.email.trim(),
            customerNumber: values.account_no.trim(),
            unitNumber: values.room_no.trim(),
        }

        const http_client = store
            ? store.get('http_client')
            : null;
        const notify = store.get('notify');

        search(http_client, checkinDetails).then((res) => {
            const {data, code} = res.data;
            // data response
            // {
            //     "alreadyLinked": false,
            //   "customerId": "cjggeqp562o088w0c80cg4wcg",
            //   "mobileNumber": "07333467777",
            //   "onlineId": null
            // }

            OnComplete(code ,data, checkinDetails);
        }).catch(error => {
            let newErrorMessageList = [handle_api_exception(error)];
            setErrors(newErrorMessageList);
            notify(handle_api_exception(error), {type: 'error'});
            setSubmitting(false);
        }).finally(() => {

        });
    }

        const schema = Yup.object().shape({
            email: Yup.string()
                .email('Invalid email address')
                .required('Email is required'),
            account_no: Yup.string().required('Account number is required'),
            room_no: Yup.string().required('Room number is required'),
        });

        return (

          <React.Fragment>
              <div className={`form-content`}>
                  <ErrorMessages errorList={errors} />
                  {showCancel && (
                    <>
                        <Button onClick={OnCancel} className={`btn-close`}>
                            X
                        </Button>
                    </>
                  )}
                  <Formik
                    enableReinitialize
                    validationSchema={schema}
                    onSubmit={ onSubmitForm}
                    initialValues={signUpDetails}
                  >
                      {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                        <Form noValidate onSubmit={handleSubmit} id="signupForm" method={`post`}>
                            <Form.Row>
                                <Form.Group
                                  as={Col}
                                  controlId="validationEmail"
                                  className="material label-top"
                                >
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      name="email"
                                      value={values.email}
                                      onChange={(e) => {
                                          e.target.value = e.target.value.trim()
                                          handleChange(e);
                                      }}
                                      isInvalid={touched.email && errors.email}
                                    />
                                    <Form.Label>Customer email</Form.Label>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.email}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group
                                  as={Col}
                                  controlId="validationAccountNo"
                                  className="material label-top"
                                >
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      name="account_no"
                                      value={values.account_no}
                                      onChange={handleChange}
                                      isInvalid={
                                        touched.account_no && errors.account_no
                                      }
                                    />
                                    <Form.Label>Customer account number</Form.Label>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.account_no}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group
                                  as={Col}
                                  controlId="validationRoomNo"
                                  className="material label-top"
                                >
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      name="room_no"
                                      value={values.room_no}
                                      onChange={handleChange}
                                      isInvalid={
                                        touched.room_no && errors.room_no
                                      }
                                    />
                                    <Form.Label>Customer room number</Form.Label>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.room_no}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>

                            <Form.Control
                              type="hidden"
                              name="recaptcha"
                              value={values.recaptcha}
                              onChange={handleChange}
                              isInvalid={touched.recaptcha && errors.recaptcha}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.recaptcha}
                            </Form.Control.Feedback>

                            <Form.Row className="justify-content-center my-2">
                                <Button
                                  type="submit"
                                  className=""
                                  disabled={submitting}
                                >
                                    {searchButtonText? searchButtonText : 'Create account'}
                                </Button>
                            </Form.Row>

                            <div id="recaptcha" />
                        </Form>
                      )}
                  </Formik>
              </div>
          </React.Fragment>
);

}

export default withStore(FindUserWithDetails);
